/* eslint-disable lines-around-comment */
import React, { useEffect, useState } from 'react';
import { setPassword as setPass } from '../../../../base/conference/actions';
import { isLocalParticipantModerator } from '../../../../base/participants/functions';
import { connect } from '../../../../base/redux/functions';
import Dialog from '../../../../base/ui/components/web/Dialog';
// @ts-ignore
import { LobbySection } from '../../../../lobby';
import PasswordSection from './PasswordSection';
/**
 * Component that renders the security options dialog.
 *
 * @returns {React$Element<any>}
 */
function SecurityDialog({ _buttonsWithNotifyClick, _canEditPassword, _conference, _locked, _password, _passwordNumberOfDigits, _showE2ee, setPassword }) {
    const [passwordEditEnabled, setPasswordEditEnabled] = useState(false);
    useEffect(() => {
        if (passwordEditEnabled && _password) {
            setPasswordEditEnabled(false);
        }
    }, [_password]);
    return (React.createElement(Dialog, { cancel: { hidden: true }, ok: { hidden: true }, titleKey: 'security.title' },
        React.createElement("div", { className: 'security-dialog' },
            React.createElement(LobbySection, null),
            React.createElement(PasswordSection, { buttonsWithNotifyClick: _buttonsWithNotifyClick, canEditPassword: _canEditPassword, conference: _conference, locked: _locked, password: _password, passwordEditEnabled: passwordEditEnabled, passwordNumberOfDigits: _passwordNumberOfDigits, setPassword: setPassword, setPasswordEditEnabled: setPasswordEditEnabled }),
            _showE2ee ? React.createElement(React.Fragment, null) : null)));
}
/**
 * Maps (parts of) the Redux state to the associated props for the
 * {@code SecurityDialog} component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {IProps}
 */
function mapStateToProps(state) {
    const { conference, e2eeSupported, locked, password } = state['features/base/conference'];
    const { roomPasswordNumberOfDigits, buttonsWithNotifyClick } = state['features/base/config'];
    const showE2ee = Boolean(e2eeSupported) && isLocalParticipantModerator(state);
    return {
        _buttonsWithNotifyClick: buttonsWithNotifyClick,
        _canEditPassword: isLocalParticipantModerator(state),
        _conference: conference,
        _dialIn: state['features/invite'],
        _locked: locked,
        _password: password,
        _passwordNumberOfDigits: roomPasswordNumberOfDigits,
        _showE2ee: showE2ee
    };
}
const mapDispatchToProps = { setPassword: setPass };
export default connect(mapStateToProps, mapDispatchToProps)(SecurityDialog);
